import React from 'react';
import chenwyChenImage from '../@people/assets/chenwy.jpg'
import zhangShuImage from '../@people/assets/zhangshu.png'

const faculty = [
  {
    name: "陈文颖",
    title: "教授",
    image: chenwyChenImage,
    email: "chenwy@tsinghua.edu.cn",
    phone: "010-62772756",
    office: "能源科学大楼C405",
    research: "能源环境经济系统模型，气候变化减缓技术评价与对策研究",
    bio: `清华大学能源环境经济研究所教授、副所长，清华大学博士。

主持国家自然科学基金委重大项目课题、科技部重点研发计划、"973"、"十二五"与"十一五"科技支撑计划课题等30余项。担任第2、3、4次《气候变化国家评估报告》领衔专家，担任IPCC第六次评估报告、第五次评估报告及第五次评估综合报告的编审。曾获教育部新世纪优秀人才计划、清华大学学术新人奖、国家能源局软科学优秀成果奖等。

主要研究方向包括能源环境经济系统模型、气候变化减缓技术评价与对策研究等。`
  },
  {
    name: "张枢",
    title: "助理研究员",
    image: zhangShuImage,
    email: "zhang-s@mail.tsinghua.edu.cn",
    phone: "010-62772759",
    office: "能源科学大楼C203",
    research: "能源系统建模，水-能源-粮食关联，能源与气候政策分析",
    bio: `清华大学能源环境经济研究所助理研究员，清华大学博士。

本科就读于清华大学电机系（导师：康重庆教授）获工学学士学位，同时获得经济学院经济学学士学位。在清华大学能源环境经济研究所获得管理学博士学位（导师：陈文颖教授）。2022年3月至2023年4月期间，在国际应用系统分析研究所（IIASA）访问学习（导师：Volker Krey教授）。

主要研究方向包括能源系统建模、水-能源-粮食关联以及能源与气候政策分析。`
  }
];

export default function Faculty() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">师资力量</h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
          </p>
        </div>
        <div className="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 pt-8 sm:mt-12 sm:pt-12 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          {faculty.map((person) => (
            <div key={person.name} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-x-8">
                <img 
                  src={person.image} 
                  alt={person.name}
                  className="h-48 w-48 rounded-lg object-cover"
                />
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">{person.name}</h3>
                  <p className="mt-2 text-base text-gray-600">{person.title}</p>
                  <p className="mt-4 text-sm text-gray-600">
                    <span className="font-medium">研究方向：</span>{person.research}
                  </p>
                  <p className="mt-2 text-sm text-gray-600">
                    <span className="font-medium">邮箱：</span>{person.email}
                  </p>
                  {person.phone && (
                    <p className="mt-2 text-sm text-gray-600">
                      <span className="font-medium">电话：</span>{person.phone}
                    </p>
                  )}
                  {person.office && (
                    <p className="mt-2 text-sm text-gray-600">
                      <span className="font-medium">办公室：</span>{person.office}
                    </p>
                  )}
                </div>
              </div>
              <p className="mt-6 text-sm leading-6 text-gray-600 whitespace-pre-line">{person.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}